export default [
    {
        path: '/system/claim-approval-settings',
        name: 'claim-approval-settings',
        component: () => import('../../pages/system/ClaimApprovalSettingsPage.vue'),
        meta: {
            title: 'Claim Approval Settings',
            requiresAuth: true,
        },
    },
]
